module.exports = __webpack_public_path__ + "static/img/honor_7.5f7217f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_7.jpg
// module id = YxGN
// module chunks = 0